<template>
	<div class="m-blank">分割线</div>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-blank {
		line-height: 40px;
		font-size: 12px;
		text-align: center;
		color: #999;
	}
</style>
